var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.mobile, function (month) {
      return _c("div", [
        _c(
          "div",
          {
            staticClass:
              "month border border-left-0 border-right-0 border-bottom-0 p-3 mt-2 mb-2",
          },
          [
            _c(
              "div",
              { staticClass: "d-block fw-500 fs-xxl color-primary-800" },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(month.period) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(month.expenses, function (item) {
              return _c("div", [
                item.expense != null
                  ? _c("div", [
                      _c("div", { staticClass: "nomer" }, [
                        _c(
                          "span",
                          { staticClass: "fs-xl badge badge-warning" },
                          [_vm._v(_vm._s(item.phone))]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "Лiмiт " +
                              _vm._s(item.limit) +
                              " грн./мiс. Тариф.план " +
                              _vm._s(item.tarif) +
                              " "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-striped limit table-responsive-xl",
                        },
                        [
                          _vm._m(0, true),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", { staticClass: "warning" }, [
                              _c("td", [
                                _c("span", { staticClass: "fs-xl" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.expense.AbonPlata) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", { staticClass: "fs-xl" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.expense.StoimZvonkov) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", { staticClass: "fs-xl" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.expense.DopYslygi) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", { staticClass: "fs-xl" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.expense.Rouming) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", { staticClass: "fs-xl" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.expense.Vsego) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "fs-xl",
                                    class: {
                                      "badge border border-danger text-danger ":
                                        parseInt(item.expense.SverchLimita) < 0,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(item.expense.SverchLimita) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n                        Даннi очiкуются з 10 числа\n                   "
                      ),
                    ]),
              ])
            }),
          ],
          2
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Абонплата")]),
        _vm._v(" "),
        _c("th", { staticClass: "small_text" }, [
          _vm._v("Понад пакет. хв. + мiж. дзв. "),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Понад пакет. смс, MB + дод. послуги ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Роумiнг")]),
        _vm._v(" "),
        _c("th", [_vm._v("Всього")]),
        _vm._v(" "),
        _c("th", [_vm._v("Понад лiмiту")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }